import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PurchasingPurchaseOrderActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/PurchaseOrder/PurchaseOrderBrowser")
	}

	render() {
		return (
			<Activity 
				name="PurchasingPurchaseOrder"
				RenderedComponent={this.RenderedComponent}
				context="PurchasingPurchaseOrder"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PurchasingPurchaseOrderActivity)
